<section class="details">
    <div class="no-form-defined" ng-if="noFormDefined()">{{'register.level.noFormDefined'|translate}}</div>
    <form name="registerForm" class="body"></form>
</section>